<!-- 首页--了解详情 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col">
        <div class="info-detail-title">
          <div class="title-img-top">
            <a href="#" class="collection">收藏</a>
            <a href="#" class="share">分享</a>
          </div>
          <div class="title-img">
            <div class="title-img-show"></div>
          </div>
          <div class="title-text">普洱市孟连县牛油果</div>
          <div class="title-logo">
            <div class="title-logo-img"></div>
            <a class="td-action-1">了解果园</a>
          </div>
          <div class="title-label">
              "孟连县牛油果"为地理标志证明商标
          </div>
        </div>
        <div class="info-list-content">
            <div class="list-content-detail">
                <div class="detail-label">
                  孟连牛油果简介
                </div>
                <div class="info-detail-content detail-content-bg">

                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoContentList from '../block/InfoContentList'
import InfoContent from '../block/InfoContent'
import InfoBlock13 from '../block/InfoBlock13'
import InfoBlock14 from '../block/InfoBlock14'

export default {
  name: 'Home01DetailA',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '5'
    }
  },
  components: {
    'infoContentList': InfoContentList,
    'infoContent':InfoContent,
  },
  data() {
    return {
      imgRootPath:this.Global.resourceDomain,
      currentImgIndex:0,
      msg: '',
      infoBlock1:InfoBlock13,
      infoBlock2:InfoBlock14,
      detail:{},
      infoPage:{total:0,list:[]},
      type:1,
    }
  },
  methods:{
    detail_Req(detailId){
      let that=this;
      let params={id:detailId};
      that.$dataApi.tradeInfo(params).then(res =>{
          that.msg=res.msg;
          that.detail=res.data;

        });
    },
  },
  created:function(){
    let that=this;
    let detailId=1543;
    this.type=that.$route.params.type;
    //this.newsDetail=this.Global.newsDetail;
    //console.log("当前导航页："+this.Global.siteDefaultNav);
    //this.newsDetail=this.Global.newsDetail;
    //this.infoList=this.Global.imgInfoList2.slice(0,this.count);
    console.log("当前导航页："+detailId);
    that.detail_Req(detailId);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}

.info-detail-title{
  position:relative;
  width:100%;
  height:480px;
  background:#fff;
  padding:20px 0px 10px 0px;
  margin-top:-20px;
  margin-bottom:0px;
  border-bottom:0px;
  text-align:left;
}
.info-detail-title .title-img{
  width: 300px;
  height:300px;
  margin:0 auto;
}

.title-img-top{
  position:absolute;
  top:30px;
  right:0px;
  height:100px;
  width:130px;
  padding-top:100px;
  background-image:url(./../../assets/product_1.png);
  background-size: auto 100px;
  background-repeat: no-repeat;
  background-position: center center;
}

.info-detail-title .title-img-show{
  text-align:center;
  width: 300px;
  height:300px;
  background-image:url(./../../assets/home_remark_03.png);
  background-size: 300px auto;
  background-repeat: no-repeat;
  background-position: center center;
}



.info-detail-title .title-text{
  float:center;
  width:100%;
  height:50px;
  text-align:center;
  font-size:24px;
  font-weight:800;
  color:#6D1659;
  line-height:30px;
}

.info-detail-title .title-label{
  width:100%;
  height:30px;
  margin-top:20px;
  font-size:14px;
  font-weight:200;
  line-height:30px;
  text-align:center;
  color:var(--color7);
  //background:green;
}

 .title-1 span{
   padding:3px 5px 3px 5px;
   margin-right:10px;
   font-size:14px;
   color:#fff;
   font-weight:100;
   line-height:30px;
   text-align:left;
   background:var(--color6);
   border-radius:5px;
 }

 .title-logo{
   position:relative;
   margin-top:40px;
   padding:0px 0px 0px 0px;
   height:30px;
   text-align:center;
   font-size:16px;
   line-height:30px;
   border-top:2px solid var(--color7);
 }

 .title-logo-img{
   position:relative;
   width: 300px;
   height:100px;
   margin:-50px auto;
   background-image:url(./../../assets/home_remark_02.png);
   background-size: 158px auto;
   background-repeat: no-repeat;
   background-position: center center;
 }

 .title-logo .td-action-1{
   display:block;
   float:right;
   height:30px;
   width:100px;
   padding:5px 15px 5px 15px;
   margin-top:0px;
   margin-right:0px;
   border:1px solid var(--color1);
   background:var(--color1);
   font-size:12px;
   color:#fff;
   line-height:20px;
   text-align:center;
 }

 .td-action-1:hover{
   cursor:pointer;
   border:1px solid var(--color6);
   background:var(--color6);
   color:#fff;
 }

.info-detail-title .title-act{
  float:left;
  width:200px;
  height:80px;
  text-align:center;
  line-height:80px;
}

.title-link-table{
  width:100%;
  padding-left:20px;
  font-size:12px;
  line-height:30px;
  color:#888;
}

.title-link-table td{
  line-height:30px;
}

.info-detail-content{

}

.list-content-detail{
  position:relative;
  width:100%;
  padding:0px;
  margin-top:20px;
  margin-bottom:20px;
  border-top:0px dashed #ddd;
  border-left:0px solid #eee;
  border-right:0px solid #eee;
  border-bottom:0px solid #eee;
}

.list-content-detail .detail-label{
  padding:0px 0px 0px 2px;
  height:50px;
  font-size:16px;
  font-weight:600;
  line-height:50px;
  text-align:left;
  //border-bottom:1px solid #eee;
}


.detail-content-bg{
  position:relative;
  height:640px;
  width:100%;
  background-image:url(./../../assets/home_remark_01.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center 0px;
}

.phone{
  padding-left:30px;
  background-image:url(./../../assets/phone.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}

.qq{
  padding-left:30px;
  background-image:url(./../../assets/qq.png);
  background-size: 16px 16px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}

.weixing{
  padding-left:30px;
  background-image:url(./../../assets/weixing.png);
  background-size: 18px 18px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home01DetailA.vue